import { NextApiRequest, NextApiResponse } from 'next';
import { ToastInterface } from 'components/layouts/Toast';
import { serverRedirect } from 'utils/helpers/server/serverRedirect';

export const serverLogout = (
    res: NextApiResponse,
    req?: NextApiRequest,
    message?: ToastInterface
): void => {
    const redirect = req && !req.url.includes('redirect=') ? req.url : null;

    serverRedirect('/logout', res, message, redirect);
};
